// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1016ea{margin-top:var(--spacer);display:grid;grid-template-columns:auto 1fr auto;gap:2.5em 1em}._8df308{margin-top:1em;font-size:.875em;gap:1em}", ""]);
// Exports
exports.locals = {
	"grid": "_1016ea",
	"small": "_8df308"
};
module.exports = exports;
